var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h1',[_vm._v("Líneas de Flete")]),_c('List',{attrs:{"items":_vm.freightlines,"columns":_vm.columns}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }